import './Header.scss';
import './responsiveHeader.scss';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Logo from '../../assets/logo.png';

const Header = () => {
    let navigate = useNavigate();
    let val = useSelector(state => state.cart.listOfProducts);

    let redirectTo = (url) => {
        navigate(url);
    };

    return (
        <div className="header_parent">

            <img className="logo_image" src={Logo} alt="logo" onClick={() => { redirectTo('/') }} />

            <div className="header_div1">
                <input className="header_input" type="text" />
                <button className="header_input_button"><ion-icon name="search-sharp" ></ion-icon></button>
            </div>

            <div className="header_div2">
                <div>
                    <span>Hello, Name</span>
                    <span>Accounts & Lists</span>
                </div>
                <div onClick={() => { redirectTo('/cart') }}>
                    <span>Returns</span>
                    <span>& Orders</span>
                </div>
                <div>
                    {/* <span><a href="#movie-section">Your</a></span>
                    <a href="#movie-section"><span>Prime</span></a> */}
                    <span>Your</span>
                    <span>Prime</span>
                </div>
                <div className="cart_parent">
                    <span className="header_cart" onClick={() => { redirectTo('/cart') }}><ion-icon name="cart-outline" size="large"></ion-icon><span>Cart</span></span>
                    {val?.length > 0 ? <span className="cart_items">{val?.length}</span> : null}
                </div>
            </div>
        </div>
    )
}

export default Header;